<template>

<app-view-sheet-field :is-sticky="isSticky" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isCondensed'],

	computed: {

		value: function() {

			return (this.item.game.age_official) ? this.item.game.age_official + '+' : '-'

		}

	}

}

</script>
